import {Animatable, Character, Combined, Layer, Object} from "../../../feature/project/Shot";
import React, {Fragment, useEffect, useState} from "react";
import {SceneElement} from "./SceneElement";


export const SceneElements = (props: {
    editable: boolean,
    prefix: string,
    elements: Array<Combined & Animatable>,
    type: "Object" | "Character" | "Layer" | "Location",
    play: boolean,
    onPlayEnd: (type: string) => void,
    selectedElement: Combined & Animatable | undefined,
    scale: number,
    onMove?: (info: { x: number, y: number, z: number, scale: number }) => void,
    onElementSelected: (element: Combined | undefined) => void
}) => {
    const [played, setPlayed] = useState<Set<string>>(new Set())
    const [play, setPlay] = useState(props.play)

    useEffect(() => {
        if (played.size === props.elements.length && play || props.elements.length == 0 && play) {
            props.onPlayEnd(props.type)
            setPlayed(new Set())
            setPlay(false)
        }
    }, [played, play])

    useEffect(() => {
        setPlay(props.play)
    }, [props.play])

    return (
        <>
            {
                props.elements && props.elements.length > 0 ?
                    props.elements.map(element => {
                        const el = (props.selectedElement?.type === props.type && props.selectedElement?.id === element.id) ? {
                            ...element,
                            scale: props.selectedElement.scale
                        } : element
                        const id = props.type + element.id

                        return <SceneElement
                            editable={props.editable}
                            key={id}
                            prefix={id}
                            element={el}
                            type={el.type ?? ""}
                            play={play}
                            onPlayEnd={() => {
                                if (play) {
                                    setPlayed(prev => new Set(prev).add(id))
                                }
                            }
                            }
                            selectedElement={props.selectedElement}
                            scale={props.scale}
                            onElementSelected={props.onElementSelected}/>
                    }) : ''
            }
        </>
    )
}